import React, { useMemo } from 'react'
import Flow from '@stackhouseos/flower-client'
import { keyBy } from 'lodash'
import { getParameterByName } from '../../utils/url'

const context = require.context('../../', true, /[\s\S]*?.flower.json$/)
const flowers = context.keys().map(filename => context(filename)).filter(e => e.type === 'flow')

const flow = keyBy(flowers, 'name')

const Subflow = React.memo(function UseFlow({ source, flowName, subReducerName, subFlowName, extraParams, startId }) {

  const extraContext = useMemo(() => ({
    loginWithMoodle: !!getParameterByName('moodle_jwt'),
    subflow: (extraParams || []).reduce((acc, inc) => ({ ...acc, [inc.name]: inc.value }), {})
  }), [extraParams])

  return flow[source] ? (
    <Flow
      destroyOnUnmount
      parentFlow={flowName}
      elements={flow[source || subFlowName].elements}
      name={subFlowName}
      extraContext={extraContext}
      startId={startId}
      reducerName={subReducerName} // non mettere punti nel nome
    />
  ) : 'NO_FLOW'
})

export default Subflow
